"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var CenteredLogoWhite_1 = __importDefault(require("./icons/CenteredLogoWhite"));
function AuthPageWrapper(_a) {
    var children = _a.children, onLogoClick = _a.onLogoClick, _b = _a.hideLogo, hideLogo = _b === void 0 ? false : _b, sidebar = _a.sidebar;
    return (react_1.default.createElement("div", { className: "overflow-x-hidden" },
        react_1.default.createElement("div", { style: {
                minHeight: '70vh',
            }, className: "text-white flex flex-col md:flex-row max-w-6xl px-8 mx-auto" },
            react_1.default.createElement("div", { className: "flex flex-shrink-0 justify-center ".concat(hideLogo && !sidebar
                    ? 'w-full md:justify-center'
                    : 'md:w-1/2 md:justify-start', " md:items-center") }, children),
            !hideLogo && (react_1.default.createElement("div", { className: "flex-1 items-center justify-center hidden md:flex" },
                react_1.default.createElement("div", { className: "cursor-pointer", onClick: onLogoClick },
                    react_1.default.createElement(CenteredLogoWhite_1.default, { className: "w-32 h-32" })))),
            sidebar && react_1.default.createElement(react_1.default.Fragment, null, sidebar))));
}
exports.default = AuthPageWrapper;
